export default __webpack_public_path__ + "media/b1fe6c704f9f8e310c0aa1532b29894b065da17820d891f0bab9cd0a7720bad9.svg";